import { createAsyncTypes, createTypes } from '../../../utils/create-types';

export const CURRENT_CHALLENGE_KEY = 'currentChallengeId';

export const ns = 'challenge';

export const actionTypes = createTypes(
  [
    'createFiles',
    'createQuestion',
    'initTests',
    'initConsole',
    'initLogs',
    'updateConsole',
    'updateChallengeMeta',
    'updateFile',
    'updateSolutionFormValues',
    'updateSuccessMessage',
    'updateTests',
    'updateLogs',
    'cancelTests',

    'logsToConsole',

    'lockCode',
    'unlockCode',
    'disableBuildOnError',
    'storedCodeFound',
    'noStoredCodeFound',
    'saveEditorContent',
    'setShowPreviewPane',
    'setShowPreviewPortal',
    'closeModal',
    'openModal',
    'setIsAdvancing',

    'previewMounted',
    'projectPreviewMounted',
    'storePortalWindow',
    'removePortalWindow',
    'challengeMounted',
    'checkChallenge',
    'executeChallenge',
    'resetChallenge',
    'stopResetting',
    'submitChallenge',
    'nextChallenge',
    'resetAttempts',
    'isAllowedChallenge',

    'setEditorFocusability',
    'toggleVisibleEditor',
    'showSingleEditor',
    'saveUserAnswer',
    'setCompletedChallengesLoading',
    'updateQuizAnswers',

    'updateChallengeIndexForSuperBlock',

    'openAiAssistant',
    'closeAiAssistant',
    'setChatAssistantSessionId',
    'setChatHistoryMessages',
    'addChatHistoryMessage',
    'setChatAssistantTyping',
    'resetAiAssistantSession',
    'openModalDeleteHistory',
    'closeModalDeleteHistory',
    'setChatAssistantAdditionalContext',
    ...createAsyncTypes('sendMessageToAi'),
    ...createAsyncTypes('fetchChatHistoryMessages'),
    ...createAsyncTypes('fetchClearHistoryMessages')
  ],
  ns
);
